import { isDuplicatePageError, setAnalytics } from '../../../thd-analytics-utils';
import {
  SERVICES_QUOTE,
  QUOTE_DETAILS,
  SERVICES_QUOTE_DETAILS,
  SERVICES_QUOTE_MODIFY,
  SERVICES_DISCOUNT_DETAILS,
  SERVICES,
  SERVICES_SIGN_IN_OTP,
  SERVICES_SIGN_IN,
  SERVICES_SIGN_IN_OTP_ENTER_CODE,
} from '../../../constants';

export function quoteViewer() {
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('quote-viewer.page-load', () => {
    digitalData.page = {
      pageInfo: {
        pageName: SERVICES_QUOTE_DETAILS,
        pageType: SERVICES_QUOTE,
      },
      category: {
        primaryCategory: QUOTE_DETAILS,
        subCategory1: SERVICES_QUOTE_DETAILS,
        subCategory2: SERVICES_QUOTE_DETAILS,
      },
    };
    setAnalytics(digitalData);
  });
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('modify-quote.page-load', () => {
    digitalData.page = {
      pageInfo: {
        pageName: SERVICES_QUOTE_MODIFY,
        pageType: SERVICES_QUOTE,
      },
      category: {
        primaryCategory: SERVICES_QUOTE,
        subCategory1: SERVICES_QUOTE_MODIFY,
        subCategory2: SERVICES_QUOTE_MODIFY,
      },
    };
    setAnalytics(digitalData);
  });
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('discount-details.page-load', () => {
    digitalData.page = {
      pageInfo: {
        pageName: SERVICES_DISCOUNT_DETAILS,
        pageType: SERVICES_QUOTE,
      },
      category: {
        primaryCategory: SERVICES_QUOTE,
        subCategory1: SERVICES_DISCOUNT_DETAILS,
        subCategory2: SERVICES_DISCOUNT_DETAILS,
      },
    };
    setAnalytics(digitalData);
  });
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('quote-otp.page-load', () => {
    digitalData.page = {
      pageInfo: {
        pageName: SERVICES_SIGN_IN_OTP,
        pageType: SERVICES_SIGN_IN,
      },
      category: {
        primaryCategory: SERVICES,
        subCategory1: SERVICES_SIGN_IN_OTP,
        subCategory2: SERVICES_SIGN_IN_OTP,
      },
    };
    setAnalytics(digitalData);
  });
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('quote-otp-enter.page-load', () => {
    digitalData.page = {
      pageInfo: {
        pageName: SERVICES_SIGN_IN_OTP_ENTER_CODE,
        pageType: SERVICES_SIGN_IN,
      },
      category: {
        primaryCategory: SERVICES,
        subCategory1: SERVICES_SIGN_IN_OTP_ENTER_CODE,
        subCategory2: SERVICES_SIGN_IN_OTP_ENTER_CODE,
      },
    };
    setAnalytics(digitalData);
  });
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('quote-viewer.page-error', ({ output = {} }) => {
    const {
      eventName = 'post page error',
      type = 'error',
      displayType = 'page',
      pageSection = '',
      message = '',
      code = ''
    } = output;

    const eventObject = {
      category: {
        primaryCategory: 'error'
      },
      eventInfo: {
        eventName,
        error: [{
          type,
          displayType,
          pageSection,
          message,
          code
        }]
      }
    };
    digitalData.page = digitalData.page || {};
    digitalData.page.error = digitalData.page.error || [];
    if (!isDuplicatePageError(digitalData, eventObject)) {
      digitalData.page.error.push(eventObject);
    }
  });
}